import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface DialogChoice<T> {
  title: string;
  value: T;
}

export interface ChoiceDialogData<T> {
  title: string;
  content: string;
  choices?: DialogChoice<T>[];
}

@Component({
  selector: 'app-choice-dialog',
  templateUrl: './choice-dialog.component.html',
  styleUrls: ['./choice-dialog.component.scss'],
})
export class ChoiceDialogComponent<T> {
  selectedChoice: T | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ChoiceDialogData<T>
  ) {}
}
